<div class="dashboardAccounts">
    <div class="links">
        <a [routerLink]="['/dashboard/accounts/requests']" routerLinkActive="router-link-active">Account Requests</a>

        <a [routerLink]="['/dashboard/accounts/all']" routerLinkActive="router-link-active">All Accounts</a>

        <a [routerLink]="['/dashboard/accounts/deleted']" routerLinkActive="router-link-active">Deleted Accounts</a>
    </div>
</div>

<div class="subSection"> 
    <div class="requests">
        <div class="title">Deleted Accounts</div>
        <!-- <app-csv-download [data]="activeListCsv" filename="all_accounts.csv"></app-csv-download> -->
    </div>
    <div class="resultsWrapper">

        <div class="row">
            <!-- <h2>Key: {{ entry[0] }}</h2> -->
            <div class="dayTitle">
                recently deleted accounts:
            </div>

            <div class="list">
                <div class="item" *ngFor="let profile of deletedList">
                    <div class="itemBox">

                        <div class="label">
                            NAME
                        </div>
                        <div class="name">
                            {{profile.firstName}} {{profile.lastName}}
                        </div>

                        <div class="label">
                            email
                        </div>
                        <div class="email">
                            {{profile.email}}
                        </div>

                        <div class="label">
                            PHONE
                        </div>
                        <div class="phone">
                            {{profile.phone}}
                        </div>
                    </div>

                    <!-- <div class="buttons">
                        <div class="button">
                            <div class="label">Approve</div>
                        </div>
                        <div class="button">
                            <div class="label">Deny</div>
                        </div>
                    </div> -->
                </div>
            </div>

        </div>




    </div>
</div>